<template>
    <div :class="['form', 'form__radio', overlay ? `form__radio--overlay` : '']">
        <div
            v-if="label"
            class="form__radio_title"
        >{{label | toCapitalize}}<span class="asterisk" v-if="required">*</span></div>
        <template v-if="$slots.default && hintPositionTop">
            <div class="form__radio_hint form__radio_hint--top">
                <slot></slot>
            </div>
        </template>
        <div class="form__radio_fields">
            <ul>
                <li
                    v-for="(item, index) in items"
                    :key="index"
                >
                    <template v-if="prevent">
                        <div @click="$emit('emit-prevent')" class="form__radio_fields_prevent"></div>
                    </template>
                    <label>
                        <input
                            type="radio"
                            class="form__radio_fields_input"
                            :disabled="disabled"
                            :id="(name + '-' +  item.name) | toKebabCase"
                            :title="item.name | toKebabCase"
                            :value="item.value"
                            :data-vv-as="dataVvAs ? dataVvAs : label.toLowerCase()"
                            v-model.prevent="newValue"
                            v-validate="vValidate"
                        />
                        <div class="form__radio_fields_text">
                            <span class="form__radio_fields_text_label">{{item.name | toCapitalize}}</span>
                            <template v-if="item.hint">
                                <span class="form__radio_fields_text_hint">{{item.hint}}</span>
                            </template>
                        </div>
                    </label>
                    <template v-if="hints">
                        <div class="form__radio_fields_hint">{{hints[index]}}</div>
                    </template>
                </li>
            </ul>
            <span
                class="form__error form__radio_error"
                v-if="errors.first(toKebabCase(name))"
            >{{ errors.first(toKebabCase(name)) }}</span>
        </div>
        <template v-if="$slots.default && !hintPositionTop">
            <div class="form__radio_hint">
                <slot></slot>
            </div>
        </template>
    </div>
</template>

<script>
export default {
  name: 'form-radio',
  props: {
    label: {
      type: String,
      required: true,
      default: 'Label'
    },
    name: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      required: true
    },
    value: {
      type: [Boolean, String, Number],
      default: ''
    },
    hints: {
      type: Array,
      default: () => []
    },
    overlay: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    //
    dataVvAs: {
      type: String,
      default: ''
    },
    vValidate: {
      default: ''
    },
    hintPositionTop: {
      type: Boolean,
      default: false
    },
    prevent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    newValue: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  inject: ['$validator']
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formradio";
</style>
